module.exports = __webpack_public_path__ + "a.no1.90f1c76d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/a.no1.jpg
// module id = 84fV
// module chunks = 0